import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParDueDiligenceService } from '../../../services/par-due-diligence/par-due-diligence.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UploadService } from '../../../services/upload/upload.service';
import { documentInformation } from '../../../model/document.model';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../../services/google_analytics/google-analytics.service';
import { Router, NavigationEnd } from "@angular/router";

declare var ga: Function;
@Component({
  selector: 'app-par-due-diligence-dialog',
  templateUrl: './par-due-diligence-dialog.component.html',
  styleUrls: ['./par-due-diligence-dialog.component.css']
})

export class ParDueDiligenceDialogComponent implements OnInit {
  public submitFormData: any;
  chooseFile: boolean = false;
  updateFile: boolean = false;
  uploadFlag: boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  onChangeFile: boolean = false;
  documentInfo: documentInformation = new documentInformation();
  previousValues: any = [];
  message: any;
  ssnNumber: any;
  states: any = [];
  listOfStates: any = [];
  onChangeFileName: string;
  isFileChanged: boolean = false;
  loginID: any;
  externalURL: any;
  loginId: any;
  minDate = new Date();
  logFormData: any;
  DocListErrMsg;
  errMsg;
  firstName;
  lastName;
  errFlag: boolean = false;
  DocListErr: boolean = false;
  data: any = {
    IssueDate: '',
    ExpirationDate: '',
    uploadedFile: '',
    FileName: '',
  }

  constructor(
    private router: Router,
    private changelogservice: ChangeLogService,
    private parDueDiligenceService: ParDueDiligenceService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private uploadService: UploadService,
    public dialogRef: MatDialogRef<ParDueDiligenceDialogComponent>, @Inject(MAT_DIALOG_DATA)
    public parData: any, ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.DocListErr = false;
    this.loginId = localStorage.getItem('loginID');
    if (this.parData.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.data = this.parData.data;
      if (this.data.ExpirationDate != null) {
        let dt = new Date(this.data.ExpirationDate);
        if (dt !== undefined)
          this.data.ExpirationDate = dt;
      }
    }

    if (this.parData.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.parData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.FileName = this.documentInfo.fileName;
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    let today = new Date();
    this.uploadFlag = false;
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
    if (this.isFileChanged === false && this.parData.type === 'update') {
      this.externalURL = this.data.DocumentLink;
      this.submitForm();
    } else {
      var uploadedFileName = 'PAR DueDiligence';
      var filePath = "Par/" + "parDuediligence/" + this.parData.data.DocumentTypeCode + "/";
      this.data.FileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": this.newFilePath1
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
          this.externalURL = this.newFilePath1;
          this.submitForm();
        });
      }, (err) => {
        this.matSpinner = false;
        
      });
    }
  }
  submitForm() {
    this.loginID = localStorage.getItem('loginID');
    const setTime = new Date(this.data.ExpirationDate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }

    if (this.parData.type === 'create') {
      this.submitFormData = {
        "issue_date": this.data.IssueDate,
        "document_type_code": this.parData.data.DocumentTypeCode,
        "document_type_name": this.parData.data.DocumentTypeName,
        "expiration_date": testTimeZone,
        "file_name": this.data.FileName,
        "document_link": this.externalURL,
        "created_by": this.loginID,
        "updated_by": this.loginID,
      }
      this.logFormData = {
        "document_type": this.parData.data.DocumentTypeName,
        "document_category": this.parData.data.DocumentCategory,
        "transaction_type": "Add",
        "modified_by": this.loginId
      }
      this.parDueDiligenceService.createDocument(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.parData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
        this.parDueDiligenceService.load.next('success');
        this.onNoClick();
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errMsg = 'PAR Change Logs' + ' ' + err;
          this.errFlag = true;
          this.matSpinner = false;
        });
      }, err => {
        this.DocListErrMsg = 'PAR Due Diligence' + ' ' + err;
        this.DocListErr = true;
        this.matSpinner = false;
      });
    } else if (this.parData.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.submitFormData = {
        "issue_date": this.data.IssueDate,
        "expiration_date": this.data.ExpirationDate,
        "file_name": this.data.FileName,
        "document_link": this.externalURL,
        "updated_by": this.loginID,
      }
      this.previousValues = localStorage.getItem('old');
      this.logFormData = {
        "document_type": this.parData.data.DocumentTypeName,
        "document_category": this.parData.data.DocumentCategory,
        "transaction_type": "Edit",
        "modified_by": this.loginId
      }
      this.parDueDiligenceService.updateDocument(this.parData.data._id, this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.parData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
        this.parDueDiligenceService.load.next('success');
        this.onNoClick();
        this.previousValues = localStorage.getItem('old');
        this.logFormData.previous_fields = JSON.parse(this.previousValues);
        this.logFormData.collection_name = "par_due_diligence_documents";
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errMsg = 'PAR Change Logs' + ' ' + err;
          this.errFlag = true;
          this.matSpinner = false;
        });
      }, err => {
        this.DocListErrMsg = 'PAR Due Diligence Service' + ' ' + err;
        this.DocListErr = true;
        this.matSpinner = false;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/par-due-diligence/par-due-diligence-dialog/par-due-diligence-dialog.component.ts